/**
 * AI Usage Module Configuration
 *
 * Super-admin-only module that surfaces AI usage analytics,
 * cost tracking, and adoption metrics across all organizations.
 * Does not appear in the top-level sidebar — accessed via Settings.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const aiUsageModule: AppModule = {
    id: 'ai-usage',

    navigation: {
        label: 'AI Usage',
        icon: 'brain',
        path: '/ai-usage',
        order: 95,
        moduleKey: 'settings.ai_usage',
        showInSidebar: false, // Accessed via Settings nav
        pages: [
            {
                label: 'Dashboard',
                path: '/ai-usage',
                icon: 'brain',
            },
        ],
    },

    routes,
}

export default aiUsageModule
